import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen bg-gray-900 text-white font-sans" data-id="element-4684" data-mp="25a4kgo1ut6mn">
      {/* Header */}
      <header className="bg-black border-b border-gray-800 py-4 px-4" data-id="element-4685" data-mp="2k7di1zhr36mt">
        <div className="max-w-4xl mx-auto flex items-center gap-4" data-id="element-4686" data-mp="2f7irjx1w0j2a">
          <Link to="/meta-martes" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-4687" data-mp="2f9bzdfo8l9bv">
            <ArrowLeft className="w-5 h-5" data-id="element-4688" data-mp="2o7xd8xirk06b" />
            <span className="text-sm" data-id="element-4689" data-mp="2o75tql2fxswe">Volver</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-4690" data-mp="32w1xw71dmlrq">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-4691" data-mp="2xxh16hlc2k81">
          Términos y Condiciones
        </h1>

        <div className="text-gray-300 text-sm md:text-base space-y-6 leading-relaxed" data-id="element-4692" data-mp="3byb62q96a31y">
          <p data-id="element-4693" data-mp="37wy1sklqa7x5">
            Al registrarte y participar en el 48 Hrs AI Cash Machine
            Masterclass, aceptas los siguientes términos y condiciones:
          </p>

          <section data-id="element-4694" data-mp="2zojcs2hwjwze">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4695" data-mp="2zpud1sc52mlr">
              1. Aceptación de Términos
            </h2>
            <p data-id="element-4696" data-mp="34mb2qqyzl90y">
              Al acceder y utilizar este sitio web y registrarte para el evento,
              aceptas estar sujeto a estos términos y condiciones, todas las
              leyes y regulaciones aplicables.
            </p>
          </section>

          <section data-id="element-4697" data-mp="3in59z6aat3y1">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4698" data-mp="3imlurxc18tnp">
              2. Uso del Servicio
            </h2>
            <p data-id="element-4699" data-mp="3nex3npor3pse">
              El contenido proporcionado en el masterclass es solo para fines
              educativos e informativos. No garantizamos resultados específicos
              de ingresos o éxito comercial.
            </p>
          </section>

          <section data-id="element-4700" data-mp="65qlnkiai4dn">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4701" data-mp="67bft90ozlaz">
              3. Propiedad Intelectual
            </h2>
            <p data-id="element-4702" data-mp="3co0mi5uc2dfu">
              Todo el contenido, materiales, y recursos proporcionados son
              propiedad de 48 Hrs AI Cash Machine y están protegidos por
              derechos de autor. No está permitida la reproducción o
              distribución sin autorización expresa.
            </p>
          </section>

          <section data-id="element-4703" data-mp="3hkqzgkaucsx1">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4704" data-mp="3vdqekl6pol42">
              4. Limitación de Responsabilidad
            </h2>
            <p data-id="element-4705" data-mp="3qdvoukyoa1kl">
              48 Hrs AI Cash Machine no será responsable de ningún daño directo,
              indirecto, incidental o consecuente que resulte del uso o la
              imposibilidad de usar nuestros servicios.
            </p>
          </section>

          <section data-id="element-4706" data-mp="2axvfab9hws5o">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4707" data-mp="2axdcevsbvfos">
              5. Consentimiento para Mensajes SMS
            </h2>
            <p className="mb-4" data-id="element-4708" data-mp="260wnhzdb0xan">
              Al marcar la casilla de consentimiento SMS durante el registro,
              aceptas recibir mensajes SMS/texto recurrentes de True Marketer
              LLC al número móvil proporcionado, incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-4709" data-mp="brzukt6rxay6">
              <li data-id="element-4710" data-mp="gqb3n1p8vhfc">Actualizaciones del programa</li>
              <li data-id="element-4711" data-mp="gp0092zpobor">Información de capacitación</li>
              <li data-id="element-4712" data-mp="2qjnaub99oy6">Mensajes de marketing/promocionales</li>
            </ul>
            <p className="mt-4" data-id="element-4713" data-mp="2smjxx6wygbv">
              Estos mensajes son enviados mediante un sistema de marcación
              telefónica automática/tecnología automatizada. La frecuencia de
              los mensajes varía. Pueden aplicar tarifas de mensajes y datos.
            </p>
            <p className="mt-4" data-id="element-4714" data-mp="3txcuqfwn6kb5">
              <strong className="text-white" data-id="element-4715" data-mp="3tynwybafvk05">Cancelación:</strong> Responde STOP
              para cancelar.
            </p>
            <p className="mt-2" data-id="element-4716" data-mp="1s5zrdvabokh7">
              <strong className="text-white" data-id="element-4717" data-mp="1s453q97o2e9f">Ayuda:</strong> Responde HELP para
              ayuda.
            </p>
            <p className="mt-4" data-id="element-4718" data-mp="3o7tena02rqzl">
              El consentimiento no es una condición de compra.
            </p>
          </section>

          <section data-id="element-4719" data-mp="3f7wof3y1ek2f">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4720" data-mp="3f7510gelfsn8">
              6. Modificaciones
            </h2>
            <p data-id="element-4721" data-mp="3a7s5z8dkjf9k">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. El uso continuado del servicio después de cambios
              constituye la aceptación de los nuevos términos.
            </p>
          </section>

          <section data-id="element-4722" data-mp="2vjnr6fhmznw2">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4723" data-mp="2vkyxon2gv9qv">
              7. Garantía y Reembolsos
            </h2>
            <p data-id="element-4724" data-mp="2rjwy254n0vod">
              Para productos de pago, ofrecemos una garantía de satisfacción de
              30 días. Si no estás satisfecho con el producto, puedes solicitar
              un reembolso completo dentro de los primeros 30 días de la compra.
            </p>
          </section>

          <section data-id="element-4725" data-mp="x1c1orx3xy7i">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4726" data-mp="x47xoapeactb">
              8. Descargo de Responsabilidad sobre Resultados
            </h2>
            <p className="mb-4" data-id="element-4727" data-mp="16zroiip3qlb7">
              48Hrs AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos.
            </p>
            <p className="mb-4" data-id="element-4728" data-mp="e9j8oxi1gczs">
              El éxito depende en parte del tiempo que dediques y de tu
              implementación de las guías, estrategias y soporte proporcionados.
            </p>
            <p className="mb-4" data-id="element-4729" data-mp="nahbjcgqqegs">
              Todo el contenido, entrenamientos, artículos y material educativo
              tiene fines formativos únicamente y no debe interpretarse como
              asesoría financiera, legal o de inversión.
            </p>
            <p data-id="element-4730" data-mp="3vqswvcbsvchd">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos.
            </p>
          </section>

          <section data-id="element-4731" data-mp="xy0y20t0er3i">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4732" data-mp="xwg3wcalxa66">
              9. Afiliaciones
            </h2>
            <p data-id="element-4733" data-mp="17odgnnh9ka70">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc. Además, este sitio no está avalado, patrocinado ni
              aprobado por Google ni Meta de ninguna manera.
            </p>
          </section>

          <section data-id="element-4734" data-mp="f1iywybtzox8">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4735" data-mp="f213ci8nd9g8">Contacto</h2>
            <p data-id="element-4736" data-mp="t0sh23jlkt3u">
              Para preguntas sobre estos términos, contacta:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-4737" data-mp="ox2q57fg9zfn">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-700" data-id="element-4738" data-mp="20chs6pminhhm">
            <p className="text-gray-500 text-sm" data-id="element-4739" data-mp="27waetm9q9ged">
              Última actualización: Febrero 2025
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 px-4" data-id="element-4740" data-mp="1xyw1hvj3p7qa">
        <div className="max-w-4xl mx-auto text-center" data-id="element-4741" data-mp="1y0qmtayab1uw">
          <p className="text-gray-600 text-xs mb-2" data-id="element-4742" data-mp="22y8nke25eart">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-4743" data-mp="2qpe5cyrnfd4r">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-4744" data-mp="2vlcvaqsml37a">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-xs mt-2" data-id="element-4745" data-mp="2luqp1n6stp19">
            <span className="text-white" data-id="element-4746" data-mp="39kuodicyf2mg">Términos</span>
            <span className="text-gray-600" data-id="element-4747" data-mp="3ecm5z3e4ty0g">|</span>
            <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-4748" data-mp="3ede34indo3su">
              Privacidad
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}